import React from 'react';
import BreadcrumbsManager from '@views/dashboard/BreadcrumbsManager';
import OrderProductUpdateForm from '@views/order-products/OrderProductUpdateForm';
import {Card, CardBody} from 'reactstrap';

export default function OrderProductForm(props: Omit<React.ComponentProps<typeof BreadcrumbsManager>, 'children'>) {
    return <BreadcrumbsManager {...props}>
        <Card>
            <CardBody>
                <OrderProductUpdateForm controllerName="OrderProducts" isIsolatedComponent/>
            </CardBody>
        </Card>
    </BreadcrumbsManager>;
}
